import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  // Define your styles here
  ul: {
    background: theme.palette.card.cardColor,
    color: theme?.palette?.card?.cardFontColor,
    "& ul": {
      color: theme.palette.card.cardFontColor,
      background: theme.palette.card.cardColor,
    },
  },
  selectMenu: {
    background: theme.palette.card.cardColor,
    "& li": {
      color: theme.palette.card.cardFontColor,
    },
  },
}));

function Index({
  slots,
  className,
  value,
  onChange,
  date,
  shouldFilter = false,
  orderTimeType = "shedulued",
  onClick,
  isFromCheckout = false,
  typeChanges = false,
  setNewChange,
  newChange = false,
  setTime,
}) {
  const classes = useStyles();
  const { checkoutDetails } = useSelector((state) => state.cart);
  const [timeslots, setTimeSlots] = useState(slots);
  const formattedTime = moment(checkoutDetails?.deliveryTime)
    .format("hh:mm a")
    .toLowerCase();
  // Time-of-day match is only meaningful when the cart's deliveryTime is
  // both set AND on the same calendar date as the picker. Without this
  // guard:
  //   - a stale deliveryTime like 5:15 PM today gets pre-selected in
  //     tomorrow's dropdown because tomorrow's slot list happens to
  //     contain a 5:15 PM entry, and
  //   - an undefined deliveryTime falls back to `moment(undefined)` =
  //     "now", so the *current wall-clock time* (e.g. 5:45 PM) silently
  //     matches a slot in tomorrow's list.
  // Either case overrides the parent's auto-select to the first
  // scheduled slot of the new date.
  const canMatchByTime =
    !!checkoutDetails?.deliveryTime &&
    (!date ||
      moment(checkoutDetails.deliveryTime).isSame(moment(date), "date"));
  let matchedSlot = canMatchByTime
    ? slots?.find((slot) => slot?.value === formattedTime)
    : undefined;
  const [timeChanges, setTimeChanges] = useState(false);
  if (
    isFromCheckout &&
    checkoutDetails?.deliveryType === "ASAP" &&
    !matchedSlot
  ) {
    matchedSlot = slots?.find((slot) => slot?.typeOfOrder === "ASAP");
  } else if (
    !isFromCheckout &&
    checkoutDetails?.deliveryType === "SCHEDULED" &&
    !matchedSlot
  ) {
    matchedSlot = slots?.find((slot) => slot?.typeOfOrder === "SCHEDULED");
  }
  // Final fallback: if the date is set but neither a time-match nor the
  // SCHEDULED/ASAP fallback above produced a slot (e.g. the parent just
  // switched to a future date and deliveryType is still stale), default
  // to the first slot so the dropdown reflects something actually on the
  // displayed date instead of showing "None".
  if (!matchedSlot && date && slots?.length > 0) {
    matchedSlot = slots[0];
  }
  // console.log("matched 333333", matchedSlot);
  const [selectedDate, setSelectedDate] = useState(matchedSlot || {});
  // console.log("selected dateeee", selectedDate);
  // console.log("timeeeeeeeeee", timeslots);

  useEffect(() => {
    if (matchedSlot) {
      setSelectedDate(matchedSlot);
      if (setTime) {
        setTime(matchedSlot?.value);
      }
    }
  }, [matchedSlot, checkoutDetails?.deliveryTime]);

  // console.log("selectyed dateeeeee", selectedDate);

  const filteredTimeSlots = (arry) => {
    return arry?.filter((item) => item.typeOfOrder !== "ASAP");
  };

  useEffect(() => {
    if (shouldFilter && slots) {
      setTimeSlots(filteredTimeSlots(slots));
    } else {
      setTimeSlots(slots);
    }
  }, [slots, shouldFilter]);

  useEffect(() => {
    if (
      checkoutDetails?.orderType &&
      slots.length > 0 &&
      isFromCheckout &&
      typeChanges &&
      !timeChanges
    ) {
      // Set the first slot as the default selected when orderType changes
      const firstSlot = slots[0];
      setSelectedDate(firstSlot);

      onChange(firstSlot, "time"); // Trigger onChange for the new selected slot

      setNewChange(true);
    }
  }, [
    checkoutDetails?.orderType,
    slots,
    isFromCheckout,
    typeChanges,
    timeChanges,
  ]);

  // useEffect(() => {
  //   if (selectedDate?.value && !slots.includes(selectedDate)) {
  //     /* ########################
  //       handle rerender of this component on deliverydate updation from delivery time slot generating hooks
  //       this results in creation of new slots which fails to match the object in our selectedDate state.
  //       This is a hack only
  //       #########################
  //     */
  //     const match = slots?.find((s) => s.value === selectedDate.value);
  //     if (match) {
  //       return setSelectedDate(match);
  //     }
  //   }

  //   const SelectedTimeFromSlots = slots?.find(
  //     (s) => s.value === selectedDate.value
  //   );
  //   if (!SelectedTimeFromSlots) {
  //     const data = slots[0];
  //     if (data) {
  //       setSelectedDate(data);
  //       onChange(data, "time");
  //     }

  //     return;
  //   }

  //   if (shouldFilter && orderTimeType !== "asap") {
  //     if (selectedDate?.value) {
  //       onChange(selectedDate, "time");
  //     } else {
  //       const data = slots[0];
  //       if (data) {
  //         setSelectedDate(data);
  //         onChange(data, "time");
  //       }
  //     }
  //   }
  // }, [selectedDate, slots, orderTimeType]);

  const sortTimeSlots = (slots) => {
    return slots.sort((a, b) => {
      // Use moment to parse the 'value' property and compare the times
      const timeA = moment(a.value, "hh:mm a");
      const timeB = moment(b.value, "hh:mm a");
      return timeA - timeB;
    });
  };

  // Assuming `timeslots` is your original array of objects
  const sortedTimeSlots = sortTimeSlots(timeslots);

  return (
    <FormControl variant="outlined" className={className}>
      {/* <InputLabel id="delivery-time">Time</InputLabel> */}
      <Select
        labelId="delivery-time"
        id="delivery-time-select"
        value={selectedDate?.value || ""}
        onChange={(e) => {
          const selected = timeslots.find(
            (slot) => slot.value === e.target.value
          );
          setSelectedDate(selected);
          onChange(selected, "time");
        }}
        onClick={() => {
          onClick();
          setTimeChanges(true);
        }}
        label="Time"
        MenuProps={{
          classes: { paper: classes.selectMenu },
        }}
        className={`font-weight-bold ${classes.ul}`}
      >
        {sortedTimeSlots?.map((elem, key) => (
          <MenuItem key={`option-${key}`} value={elem.value}>
            {elem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

Index.defaultProps = {
  buffer: null,
};

Index.propTypes = {
  buffer: PropTypes.number,
  className: PropTypes.string.isRequired,
};

export default Index;
